import React from 'react';
import { useTranslation } from 'react-i18next';
import { CellContext } from '@tanstack/react-table';
import { DeviceDashboardTableData } from '@/types/operational-ui.types';
import { TableButton } from '@/components/ui/TableButton';
import { Eye, Activity, Clock } from 'lucide-react';
import { PERMISSIONS } from '@/contexts/PermissionsContext';

interface DeviceDashboardActionsCellProps {
  info: CellContext<DeviceDashboardTableData, any>;
  actions: {
    onViewOperations: (deviceId: string) => void;
    onViewAllLectures: (deviceId: string) => void;
    onViewAllPendingLectures: (deviceId: string) => void;
    // onCenterMap?: (coordinates: { lat: number; lng: number }) => void;
  };
}

export const DeviceDashboardActionsCell: React.FC<DeviceDashboardActionsCellProps> = ({
  info,
  actions,
}) => {
  const { t } = useTranslation();
  const device = info.row.original;

  return (
    <div className="flex space-x-1">
      <TableButton
        permission={PERMISSIONS.OPERATIONAL_READ}
        onClick={(e) => {
          e.stopPropagation();
          actions.onViewOperations(device.id);
        }}
        icon={<Eye className="h-4 w-4" />}
        label={t('pages.operations.devices.actions.viewOperations')}
        variant="primary"
      />

      <TableButton
        permission={PERMISSIONS.OPERATIONAL_READ}
        onClick={(e) => {
          e.stopPropagation();
          actions.onViewAllLectures(device.id);
        }}
        icon={<Activity className="h-4 w-4" />}
        label={t('pages.operations.devices.actions.viewLectures')}
        variant="secondary"
      />

      <TableButton
        permission={PERMISSIONS.OPERATIONAL_READ}
        onClick={(e) => {
          e.stopPropagation();
          actions.onViewAllPendingLectures(device.id);
        }}
        icon={<Clock className="h-4 w-4" />}
        label={t('pages.operations.devices.actions.viewPendingLectures')}
        variant="secondary"
      />

      {/*
      {actions.onCenterMap && device.lastOperationTimestamp && ( // TODO: REVIEW THIS FOR CENTER MAP IN CASE IT IS NOT USED
        <TableButton
          permission={PERMISSIONS.OPERATIONAL_READ}
          onClick={(e) => {
            e.stopPropagation();
            // For now, use default coordinates - in real implementation, 
            // this would come from the device's last known location
            // actions.onCenterMap?.({ lat: -34.6037, lng: -58.3816 });
          }}
          icon={<Map className="h-4 w-4" />}
          label={t('pages.operations.devices.actions.centerMap')}
          variant="secondary"
        />
      )}
      */}
    </div>
  );
};
